import { createFileRoute } from '@tanstack/react-router'
import PulseCarteiraPage from '@/pages/dashboard/pulse-carteira-page'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/pulse-carteira',
)({
  component: function PulseCarteiraRoute() {
    const { dashboardId } = Route.useParams()
    return (
      <RequireModule module={MODULES.PULSE} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
          <PulseCarteiraPage />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
